import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'collapse-panel',
	template: require('./collapse-panel.component.html'),
	styles: [require('./collapse-panel.component.scss')]
})
export class CollapsePanelComponent {
	@Input() title: any;
	@Input() isOpen = true;
	@Input() noCollapsing: boolean;
	@Output() toggle: EventEmitter<any> = new EventEmitter();

	private get _isToggle() {
		return this.toggle && this.toggle.observers.length > 0;
	}

	saveExpanded(event) {
		if (this._isToggle) {
			this.toggle.emit(event);
		} else {
			this.isOpen = !this.isOpen;
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/collapse-panel/collapse-panel.component.ts